import { withInstall } from '../utils'
import _PageSize from './PageSize'
import './index.scss'
export const PageSize = withInstall(_PageSize)
export default PageSize
